import { type UseQueryResult, useQuery } from 'react-query';
import { PptAccessListParticipantService } from '../../services/wealthlane-customer-services/services/PptAccessListParticipantService';
import { type PagedResultDto_ParticipantPptAccessListItemDto } from '../../services/wealthlane-customer-services/models/PagedResultDto_ParticipantPptAccessListItemDto';
import { type Wealthlane_AdvisorApi_PptAccessListStatus } from '../../services/wealthlane-customer-services/models/Wealthlane_AdvisorApi_PptAccessListStatus';

export type ParticipantPptAccessListParams = {
  status?: Wealthlane_AdvisorApi_PptAccessListStatus;
  skipCount?: number;
  maxResultCount?: number;
  sorting?: string;
};

const useGetParticipantPptAccessList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  listParams: ParticipantPptAccessListParams,
): UseQueryResult<PagedResultDto_ParticipantPptAccessListItemDto | undefined, unknown> => {
  const { sorting = '', skipCount = 0, maxResultCount = 100, status } = listParams;

  return useQuery(
    ['getParticipantPptAccessList', sorting, skipCount, maxResultCount, status],
    async () =>
      await handleRequest(
        PptAccessListParticipantService.getApiCustomerApiAppPptAccessListParticipant(
          status,
          sorting,
          skipCount,
          maxResultCount,
        ),
      ),
  );
};

export default useGetParticipantPptAccessList;
